import { isMobile, getUA } from 'react-device-detect';

import * as actions from './ActionTypes';
import ApiService from '../services/ApiService';

export const handleError = error => ({
  type: actions.HANDLE_ERROR_BOUNDARY,
  error,
  userAgent: getUA,
});

export const sendingErrorStarted = error => ({
  type: actions.SENDING_ERROR_STARTED,
  payload: {
    error,
  },
  sendingAt: Date.now(),
});

export const sendingErrorSuccess = () => ({
  type: actions.SENDING_ERROR_SUCCESS,
  receivedAt: Date.now(),
});

export const sendingErrorFailure = error => ({
  type: actions.SENDING_ERROR_FAILURE,
  error,
  receivedAt: Date.now(),
});

export const sendingError = error => (dispatch, getState) => {
  const {
    columnNumber,
    stack,
    lineNumber,
    message,
    fileName,
  } = error;

  dispatch(handleError(error));

  const data = {
    error: {
      code: '0',
      columnNumber,
      fileName,
      lineNumber,
      message,
      path: getState().router.location.pathname,
      stack,
      status: '0',
    },
    resolution: `${window.innerWidth}x${window.innerHeight}`,
    ontouch: isMobile,
  };

  dispatch(sendingErrorStarted(data));
  return ApiService.sendError(data).then(
    () => dispatch(sendingErrorSuccess()),
    err => dispatch(sendingErrorFailure(err.response)),
  );
};
